import styled from 'styled-components'
import { BodyDefault } from '../typography/styled'

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 150px;
  padding: 4px 0;
  border: ${({theme}) => `1px solid ${theme.grey[350]}`};
  border-radius: ${({theme}) => theme.radius.control};
  background-color: ${({theme}) => theme.palette[10]};
  box-shadow: ${({theme}) => `${theme.shadows.hover}, ${theme.shadows.menu}`};
`

export const SettingsLink = styled(BodyDefault).attrs({ as: 'a' })`
  box-sizing: border-box;
  min-height: 36px;
  padding: 8px 12px;
  color: ${({theme}) => theme.palette[850]};
  text-decoration: none;

  &:hover,
  &:focus-visible {
    outline: none;
    background-color: ${({theme}) => theme.isDark ? theme.palette[200] : theme.grey[100]};
  }
`
